import { useEffect } from "react";
const {kakao} = window;

export default function Location () {
    const initMap = () => {
        let container = document.getElementById('map'); //지도를 담을 영역의 DOM 레퍼런스
        let options = { //지도를 생성할 때 필요한 기본 옵션
            center: new kakao.maps.LatLng(37.3465021, 126.976791), //지도의 중심좌표.
            level: 3 //지도의 레벨(확대, 축소 정도)
        };
        let map = new kakao.maps.Map(container, options); //지도 생성 및 객체 리턴
        let marker = new kakao.maps.Marker({ 
            position: map.getCenter() 
        }); 
        marker.setMap(map);
    };
    useEffect(() => {
        initMap();
    }, []);
    return (
        <section id="contact" className="contact">
            <div className="container">
                <div className="section-title">
                    <span>오시는길</span>
                    <h2>오시는길</h2>
                    {/* <p>Sit sint consectetur velit quisquam cupiditate impedit suscipit alias</p> */}
                </div>
            
                <div className="col-lg-12">
                    <div className="col-lg-12 col-md-12">
                        <div className="info-box mb-4">
                        <i className="bx bx-map"></i>
                        <h3>위치</h3>
                        <p>경기도 의왕시 왕곡로22, 6층 (왕곡동, 광원빌딩)</p>
                        </div>
                    </div>
                </div>
                <div className="row" data-aos="fade-up">
                    <div className="col-lg-12">
                        {/* <iframe className="mb-12 mb-lg-12" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6334.191625899515!2d126.68402716357022!3d37.45845964004017!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b794204ae16cf%3A0x11ad9f6947f7de9b!2z6rSR7JuQ67mM65Sp!5e0!3m2!1sko!2skr!4v1691403529280!5m2!1sko!2skr" frameBorder="0" style={{border:0, width: '100%', height: '384px'}} allowFullScreen></iframe> */}
                        <div id="map" style={{width: '100%', height: '500px'}}></div>
                    </div>
                    {/* <div className="col-lg-6">
                        <form action="forms/contact.php" method="post" role="form" className="php-email-form">
                        <div className="row">
                            <div className="col-md-6 form-group">
                            <input type="text" name="name" className="form-control" id="name" placeholder="Your Name" required />
                            </div>
                            <div className="col-md-6 form-group mt-3 mt-md-0">
                            <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" required />
                            </div>
                        </div>
                        <div className="form-group mt-3">
                            <input type="text" className="form-control" name="subject" id="subject" placeholder="Subject" required />
                        </div>
                        <div className="form-group mt-3">
                            <textarea className="form-control" name="message" rows="5" placeholder="Message" required></textarea>
                        </div>
                        <div className="my-3">
                            <div className="loading">Loading</div>
                            <div className="error-message"></div>
                            <div className="sent-message">Your message has been sent. Thank you!</div>
                        </div>
                        <div className="text-center"><button type="submit">Send Message</button></div>
                        </form>
                    </div> */}
                </div>
            </div>
        </section>
    );
}